module.exports = __webpack_public_path__ + "media/luxury-2026/location-library-960-760259c0.jpg";